import { render, staticRenderFns } from "./uploadVehicle.vue?vue&type=template&id=1634e1f5&scoped=true"
import script from "./uploadVehicle.vue?vue&type=script&lang=js"
export * from "./uploadVehicle.vue?vue&type=script&lang=js"
import style0 from "./uploadVehicle.vue?vue&type=style&index=0&id=1634e1f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634e1f5",
  null
  
)

export default component.exports